export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/services-cta-bg.bad642cc-822b29.png";